/** @format */

import { Locale } from "../../i18n/init";
import { XMLBuilder } from "fast-xml-parser";
import { store } from "../../../app/store";
import { setAddNotifications } from "../../notifications/notificationsSlice";
import { resourcesApi } from "../../../app/services/resource/resourcesApi";

const processString = (str: string) =>
  str
    .replaceAll("\n", "")
    // Glossary terms
    .replace(
      /<span\sdata-glossary="(.*?)"[^>]*>([\s\S]*?)<\/span>/g,
      '<span class="glossary-term"><span class="term">$2</span> <span class="definition">($1)</span></span>',
    )
    // // Fill in the blank
    .replace(
      /<input\s+[\s\S]*?class="blank-input"\s+[\s\S]*?data-answer="(.*?)"[\s\S]*?\/>/g,
      '<span class="blank-input">$1</span>',
    )
    // // Fill in the blank Dropdown
    .replace(
      /<select\s+[\s\S]*?class="blank-dropdown"\s+[\s\S]*?data-answer="(.*?)">\s*<\/select>/g,
      '<span class="blank-dropdown">$1</span>',
    );

const loopObject = (object: any, locale: Locale) => {
  const obj = { ...object };

  if (!locale) return;
  for (const key in obj) {
    let value = obj[key];
    let newKey = Number.isInteger(Number(key)) ? `_${key}` : key;
    if (key === "$metadata") newKey = "_metadata";
    if (
      typeof value === "object" &&
      key !== "lastEdit" &&
      key !== "lastLog" &&
      key !== "downloadFiles"
    ) {
      /** Only translate if the current language isn't blank and the other language field exists */
      if (
        value &&
        value[locale] &&
        value.en !== undefined &&
        value.cy !== undefined
      ) {
        const tmp = Array.isArray(value[locale])
          ? value[locale].map((lvl1: any) => ({
              SELECTS: Array.isArray(lvl1)
                ? lvl1.map((str) => ({ OPTIONS: processString(String(str)) }))
                : processString(String(lvl1)),
            }))
          : processString(String(value[locale]));
        // tmp = typeof value[locale]==='string' ? String(value[locale]) ? tmp.map();
        // XML.parseString(tmp, (err, result) => { if(!err) tmp = result; });
        obj[newKey] = {
          TRANSLATE: tmp,
        };
      } else {
        if (Array.isArray(value) && value.length < 1)
          value = [...value].push(null);
        obj[newKey] = loopObject(value, locale);
      }
      if (newKey !== key) delete obj[key];
    } else {
      if (key.toLowerCase() !== "uuid") delete obj[key];
    }
  }
  return obj;
};

/** Function to download entire resource for translation */
export const downloadTranslation = async (
  resourceCode: string,
  locale: Locale,
) => {
  const dispatch = store.dispatch;
  const { data: fullResource, error } = await dispatch(
    resourcesApi.endpoints.getFullResource.initiate({ code: resourceCode }),
  );
  if (error !== undefined) {
    dispatch(
      setAddNotifications({
        date: new Date().toISOString(),
        id: `resource-${resourceCode}-download`,
        title: "Downloaded Translation",
        msg: `Failed to download ${resourceCode}.`,
        type: "danger",
      }),
    );
  }

  if (fullResource) {
    const newResource = { root: loopObject(fullResource.Object, locale) };

    const builder = new XMLBuilder({ oneListGroup: true });
    const _content = builder.build(newResource);

    const dummylink = document.createElement("a");
    dummylink.download = `${resourceCode}${locale ? "." + locale : ""}.xml`;
    dummylink.href = `data:applicaton/xml;charset=utf-8,${encodeURIComponent(
      '<?xml version="1.0" encoding="UTF-8" ?>' + _content,
    )}`;
    dummylink.click();

    // Notify user resource downloaded successfully
    const now = new Date().toISOString();
    dispatch(
      setAddNotifications({
        date: now,
        id: `resource-${resourceCode}-download`,
        title: `Downloaded Translation`,
        msg: `Successfully downloaded ${resourceCode}${
          locale ? "." + locale : ""
        }.xml`,
        type: "success",
      }),
    );
  }
};
